import React from "react";
import { Link } from "react-router-dom";

// REMINDER: Two logo variants for light vs dark surfaces.
export const LOGO_LIGHT_BG =
  "https://customer-assets.emergentagent.com/job_upgrade-web-4/artifacts/qbbdrrns_FFDD0762-32FF-400B-8794-0C2705294CCC.png";
export const LOGO_DARK_BG =
  "https://customer-assets.emergentagent.com/job_upgrade-web-4/artifacts/9kc97uyn_74EB1DD1-D50B-4BCC-9CDA-E60D9ED96FC8.png";

/**
 * ConnectHer logo - chooses the appropriate variant for light vs dark surfaces.
 *
 * @param {"light"|"dark"} surface - The surface the logo is sitting on
 * @param {boolean} as - When true renders a Link to /, else a div
 * @param {string} size - Tailwind height utility e.g. "h-10"
 * @param {boolean} compact - If true renders just the mark with no wordmark on small screens
 */
export default function Logo({
  surface = "light",
  to = "/",
  size = "h-12 md:h-14",
  className = "",
  testid = "brand-logo",
}) {
  const src = surface === "dark" ? LOGO_DARK_BG : LOGO_LIGHT_BG;
  const hqBadge = (
    <span
      className={`ml-2 text-[10px] md:text-xs font-semibold uppercase tracking-[0.2em] px-1.5 py-0.5 rounded ${
        surface === "dark"
          ? "text-gold border border-gold/40"
          : "text-navy/70 border border-navy/20"
      }`}
      aria-hidden="true"
    >
      HQ
    </span>
  );
  const inner = (
    <>
      <img
        src={src}
        alt="ConnectHer HQ — Build · Connect · Empower"
        className={`${size} w-auto object-contain select-none ${
          surface === "dark" ? "" : "mix-blend-multiply"
        }`}
        draggable={false}
      />
      {hqBadge}
    </>
  );
  if (!to) {
    return (
      <div className={`flex items-center ${className}`} data-testid={testid}>
        {inner}
      </div>
    );
  }
  return (
    <Link to={to} className={`flex items-center group ${className}`} data-testid={testid}>
      {inner}
    </Link>
  );
}
